import React from 'react';
import Select from '@material-ui/core/Select';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles(theme => ({
    dropdown: {

    },
}));


const QuestionSelector = ({ selectedQuestion, questions, handleSelectedQuestionChange}) => {
    const classes = useStyles()

    return (
        <Box>
            <Select
                className={classes.dropdown}
                variant="outlined"
                value={selectedQuestion ?? 0}
                onChange={handleSelectedQuestionChange}
            >
                <MenuItem value="0">
                    All questions
                </MenuItem>
                {questions.length === 0 &&
                    <MenuItem disabled>No question available for current selection</MenuItem>
                }
                {questions.length !== 0 && questions.map(question => (
                    <MenuItem
                        key={`question-${question.id}-${question.label_template}`}
                        value={question.id}
                    >
                        {question.label_template}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    )
}

export default QuestionSelector
